import styles from './style.postcss';

import React, { Component } from 'react';
import is from 'is_js';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { PageCard, Grid, testClass, mediaQuery } from 'omni-common-ui';

import ExpansionButton from 'components/ExpansionButton';
import ReadOnlyField from './ReadOnlyField';

const PROGRESS_ADVISOR = 'Progress Advisor ';
const TEACHERS_FIRST = 'Teacher 1';
const TEACHERS_SECOND = 'Teacher 2';
const TEACHERASSISTANT = 'Teaching Assistant ';

class GroupDetail extends Component {
  constructor(props) {
    super(props);
    this._bigQueryListener = this._bigQueryListener.bind(this);
    this._hugeQueryListener = this._hugeQueryListener.bind(this);
    this._bigQuery = mediaQuery(`(min-width: ${styles.bigViewportWidth})`);
    this._hugeQuery = mediaQuery(`(min-width: ${styles.hugeViewportWidth})`);
    this.state = {
      isInBigViewport: !! this._bigQuery.matches,
      isInHugeViewport: !! this._hugeQuery.matches,
    };
  }

  componentDidMount() {
    this._bigQuery.addListener(this._bigQueryListener);
    this._hugeQuery.addListener(this._hugeQueryListener);
  }

  componentWillUnmount() {
    this._bigQuery.removeListener(this._bigQueryListener);
    this._hugeQuery.removeListener(this._hugeQueryListener);
  }

  _bigQueryListener(mql) {
    this.setState({ isInBigViewport: !! mql.matches });
  }

  _hugeQueryListener(mql) {
    this.setState({ isInHugeViewport: !! mql.matches });
  }

  render() {
    const { isExpanded, groupSummary, onExpandBottonClick, timeZone } = this.props;
    const groupSummaryDisplayItems = [];
    prepareGroupSummaryDisplayItems.call(this);

    return <PageCard className={classnames(styles.GroupDetail_container,
          testClass('group-detail-view'))}>
      <PageCard.Heading text="Group Details" />
      <PageCard.Content className={styles.GroupDetail_content}>
        <Grid className={styles.GroupDetail_content_grid}>
          <Grid.Group>
            {renderGridItems()}
          </Grid.Group>
        </Grid>
      </PageCard.Content>
      {renderExpansionButton()}
    </PageCard>;

    function renderGridItems() {
      return groupSummaryDisplayItems.map((source) => <Grid.Item xs={12}
          sm={6}
          md={4}
          lg={3}
          className={styles.GroupDetail_item}>
        <ReadOnlyField boardTitle={source.title}
            boardValue={source.value}
            className={source.className} />
      </Grid.Item>);
    }

    function prepareGroupSummaryDisplayItems() {
      groupSummaryDisplayItems.push({
        title: PROGRESS_ADVISOR,
        value: groupSummary.pa,
        className: testClass('progress-advisor'),
      });
      groupSummaryDisplayItems.push({
        title: TEACHERS_FIRST,
        value: groupSummary.mainTeacherName,
        className: testClass('teacher-1'),
      });
      if (isExpanded || this.state.isInBigViewport || this.state.isInHugeViewport) {
        groupSummaryDisplayItems.push({
          title: TEACHERS_SECOND,
          value: groupSummary.coTeacherName,
          className: testClass('teacher-2'),
        });
      }
      if (isExpanded || this.state.isInHugeViewport) {
        groupSummaryDisplayItems.push({
          title: TEACHERASSISTANT,
          value: groupSummary.teacherAssistant,
          className: testClass('assistant'),
        });
      }
      if (isExpanded) {
        groupSummary.sessionSchedules.map((session, index) => {
          const sessionNumber = index + 1;
          groupSummaryDisplayItems.push({
            title: `Session ${sessionNumber}`,
            value: getClassDate(session.period),
            className: testClass(`session-${sessionNumber}`),
          });
          return false;
        });
      }
    }

    function getClassDate(period) {
      if (is.undefined(period.start) || is.undefined(period.end)) return '';
      return `${period.start.clone().tz(timeZone).format('ddd, HH:mm')}-${period.end.clone().tz(timeZone).format('HH:mm')}`;
    }

    function renderExpansionButton() {
      return <ExpansionButton isExpand={isExpanded}
          onExpansionButtonClick={() => onExpandBottonClick()}
          className={testClass('expand-group-details')} />;
    }
  }
}

GroupDetail.propTypes = {
  groupSummary: PropTypes.object.isRequired,
  timeZone: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onExpandBottonClick: PropTypes.func.isRequired,
};

export default GroupDetail;



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/GroupDetail/index.jsx